export default function ClarksvilleHowItWorksSection() {
  const steps = [
    {
      step: "01",
      title: "Call or Submit Online",
      description:
        "Reach us 24/7 by phone or submit your request online. Tell us your situation — deployment timeline, travel date, or emergency need.",
    },
    {
      step: "02",
      title: "Document Review",
      description:
        "We review your documents, confirm eligibility, and tell you exactly what we need. No surprises, no rejection letters later.",
    },
    {
      step: "03",
      title: "Application Processing",
      description:
        "Our specialists process your application with priority handling, coordinating directly with passport processing centers.",
    },
    {
      step: "04",
      title: "Delivery to Your Door",
      description:
        "Your passport is delivered to your door or Fort Campbell address. No trips to Nashville. No waiting in lines. Done.",
    },
  ];

  return (
    <section id="how-it-works" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">How It Works</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Simpler Than You Think
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Four steps from call to delivery. We do the hard part — you just pack your bags.
          </p>
        </div>

        <div className="relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-16 left-0 right-0 h-0.5 bg-gray-200 z-0">
            <div className="absolute left-[12.5%] right-[12.5%] h-full bg-[#F6C344]/30"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative z-10 text-center flex flex-col items-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1A365D] text-white font-bold text-lg mb-5 flex-shrink-0">
                  {step.step}
                </div>
                <h3 className="font-serif text-lg font-bold text-[#1A365D] mb-3">{step.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed text-center">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 text-center">
          <a
            href="tel:+18001234567"
            className="inline-flex items-center gap-2 bg-[#F6C344] text-[#1A365D] font-semibold px-10 py-4 rounded-lg hover:bg-[#e5b33f] transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            Start Step 1 — Call Now
          </a>
        </div>
      </div>
    </section>
  );
}